import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
//import { AssetService } from '../services/asset.service';
import { AdalService } from '../adal/adal.service';
//import { AdConfigService } from '../services/adconfig.service';
//import { AuthHelper } from "../services/authService";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'

import { AppSettingsService } from '../services/appsettings.service';
//var Settings = require('../clientappsettings_js.json');
import { SimpleNotificationsComponent } from 'angular2-notifications';

@Component({
    //selector: 'section',
    template: require('./admin.component.html'),
    //providers: [AppSettingsService]//,
    //{provide: AppSettingsService, useValue: AppSettingsService }
    //providers: [AppSettingsService,
    //    { provide: APP_INITIALIZER, useFactory: (settings: AppSettingsService) => () => { settings.load() }, deps: [AppSettingsService], multi: true },]
    //providers: [{ provide: AdConfigService, useFactory: (http: Http) => { new  AdConfigService(http) }, deps: [Http] }]//, AuthHelper]
})

export class AdminComponent implements AfterViewInit  {

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 2,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        //position: ['right', 'bottom']
    };


    constructor(
        private router: Router,
        private adalService: AdalService,
        //private adConfigService: AdConfigService,
        private appSettingsService: AppSettingsService
        //private adConfig: AzureAdConfig
    ) {
        //this.appSettingsService.setRedirectPath(window.location.pathname);
        //this.appSettingsService.setRedirectUri(window.location.origin + window.location.pathname);
        //this.adalService.init(this.appSettingsService.adalConfig);
        //this.adalService.handleWindowCallback();
        //if (this.adalService.userInfo.isAuthenticated) {

        //    this.router.navigate([this.appSettingsService.adalConfig.redirectPath]);
        //} else {
        //    this.adalService.clearCache();
        //    this.adalService.login();
        //}
    }

    //constructor(private _dataService: DataService, auth: AuthHelper) {
    //    this.message = "Hello from HomeComponent constructor";
    //    auth.handleRedirect();
    //    // Route the user to a view based on presence of access token
    //    if (auth.access_token == null && !auth.isLoggingIn) {
            
    //        // access token exists...display the users files
    //        //router.navigate(["/Files"]);
            
    //        auth.login();
            
    //    }
    //    //else {
    //     //   this.isLoggingIn = false;
    //        //    // access token doesn't exist, so the user needs to login
    //        //    router.navigate(["/Login"]);
    //    //}
    //}

    ngAfterViewInit() {
        //var adalConfig = JSON.parse(localStorage.getItem("sent-cfg"));
        //if (adalConfig)
        //{
        //    this.adalService.init(adalConfig);
        //    localStorage.removeItem("sent-cfg");
        //}











        //this.appSettingsService.setRedirectPath(window.location.pathname);
        //this.appSettingsService.setRedirectUri(window.location.origin + window.location.pathname);
        //this.adalService.init(this.appSettingsService.adalConfig);
        //this.adalService.handleWindowCallback();
        //if (this.adalService.userInfo.isAuthenticated) {

        //    this.router.navigate([this.appSettingsService.adalConfig.redirectPath]);
        //}
        //else {
        //    this.adalService.login();
        //}

        

        //if (!this.adalService.userInfo.isAuthenticated) {
        //    this.adalService.login();
        //}
        //this._dataService
        //    .GetAll()
        //    .subscribe(data => this.values = data,
        //    error => console.log(error),
        //    () => console.log('Get all complete')); 
    }
}


// WEBPACK FOOTER //
// ./app/admin/admin.component.ts